export default __webpack_public_path__ + "static/media/blocks.5773fd09.svg";